// Site types based on ARI API data contracts

/**
 * AR Connect Site Status enum matching MSSQL tinyint values
 */
export enum ARConnectSiteStatus {
  Draft = 1,
  Live = 2,
  Disabled = 3,
}

// Site interface (from ARI API /api/sites/{id} response)
export interface Site {
  id: number;
  name: string;
  logoFile: string;
  hideCoverageAutocomplete: boolean;
  require2FA: boolean;
  siteCoverage: {
    name: string;
    id: number;
  };
  twitterAccess: boolean;
  analystQuoteAccess: boolean;
  analystResearchAccess: boolean;
  analystBlogAccess: boolean;
  aiProvider: string;
  enabledFeatureFlags: number[];
  arConnectSlug?: string | null; // Custom URL slug for AR Connect
  arConnectSiteStatus?: ARConnectSiteStatus | null; // AR Connect site status
  slug?: string; // Computed slug: arConnectSlug or name (lowercase, spaces to dashes)
}
